import api from "@/app/api";
import Guid from "@/app/types/common/guid";
import { Instant, LocalDate, LocalTime } from "@js-joda/core";
import {ModelObject, BaseModelObject, ValidationRule} from "@/app/services/modelObject";
import ServiceBase from "@/app/services/serviceBase";
import converters from "@/app/services/converters"

// Model Objects

export class OutletSubType extends ModelObject<OutletSubType> {

    public version: number = 0;
    public id: Guid = Guid.createEmpty();
    /**
    * Sub Type Description
    * Not Nullable
    * Not Empty
    * Max Length : 1000
    */
    public name: string = "";
    public isHidden: boolean = false;

    public constructor(jsonSerializedObject?: any) {
        super();
        if (jsonSerializedObject) {
          this.version = jsonSerializedObject.version;
          this.id = Guid.parseOrEmpty(jsonSerializedObject.id);
          this.name = jsonSerializedObject.name;
          this.isHidden = jsonSerializedObject.isHidden;
        }

    }

    public toJsonSerializedObject(): any {
        const toRet = {} as any;
        toRet.version = this.version;
        toRet.id = this.id.toString();
        toRet.name = this.name;
        toRet.isHidden = this.isHidden;
        return toRet;
    }

    public toProto(): any {
      return this.toJsonSerializedObject();
    }

    public toBinary(): Uint8Array {
      return new TextEncoder().encode(JSON.stringify(this.toJsonSerializedObject()));
    }

    public validationRules: ValidationRule = [
            {field: "version", rule: (v: any) => v == null || v >= -9223372036854775808 || "Version is not greater than minimum allowed value: -9223372036854775808"},
            {field: "version", rule: (v: any) => v == null || v <= 9223372036854775807 || "Version is above maximum allowed value: 9223372036854775807"},
            {field: "id", rule: (v: any) => !v.isEmpty() || "OutletSubType.Id cannot be empty"},
            {field: "name", rule: (v: any) => v == null || v.length !== 0 || "Name cannot be empty"},
            {field: "name", rule: (v: any) => v == null || v.length <= 1000 || "Name has too many characters (1000)"},
    ];
}


export class OutletSubTypeService extends ServiceBase {

  public async getAllOutletSubTypes(tenantId: Guid, opts?: {requestTimeoutMs?: number, sessionToken?: string}): Promise<OutletSubType[]> {
    const req = {
    tenantId:tenantId.toString(),
    };
    const extractor = (response:any) => response.outletSubTypes.map((v: any) => new OutletSubType(v));;
    return this.makeJsonRequest("outletSubType/v1/getAllOutletSubTypes", req, false, extractor, opts);
  };

  public async getOutletSubType(tenantId: Guid, outletSubTypeId: Guid, opts?: {requestTimeoutMs?: number, sessionToken?: string}): Promise<OutletSubType> {
    const req = {
    tenantId:tenantId.toString(),
    outletSubTypeId:outletSubTypeId.toString(),
    };
    const extractor = (response:any) => new OutletSubType(response.outletSubType);;
    return this.makeJsonRequest("outletSubType/v1/getOutletSubType", req, false, extractor, opts);
  };

  public async saveOutletSubType(tenantId: Guid, outletSubType: OutletSubType, opts?: {requestTimeoutMs?: number, sessionToken?: string}): Promise<void> {
    const req = {
    tenantId:tenantId.toString(),
    outletSubType:outletSubType.toJsonSerializedObject(),
    };
    const extractor = null;
    return this.makeJsonRequest("outletSubType/v1/saveOutletSubType", req, true, extractor, opts);
  };

  public async setOutletSubTypeIsHidden(tenantId: Guid, outletSubTypeId: Guid, hide: boolean, opts?: {requestTimeoutMs?: number, sessionToken?: string}): Promise<void> {
    const req = {
    tenantId:tenantId.toString(),
    outletSubTypeId:outletSubTypeId.toString(),
    hide:hide,
    };
    const extractor = null;
    return this.makeJsonRequest("outletSubType/v1/setOutletSubTypeIsHidden", req, true, extractor, opts);
  };
}

export const outletSubTypeService = new OutletSubTypeService();